import {
  Directive,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
  inject,
} from '@angular/core';

@Directive({
  selector: '[appDropdownSheet]',
  host: { class: 'dropdown-sheet' },
})
export class DropdownSheetDirective implements OnInit, OnDestroy {
  el = inject(ElementRef);
  renderer = inject(Renderer2);

  backdrop!: HTMLElement;

  ngOnInit() {
    this.backdrop = this.renderer.createElement('div');
    this.renderer.addClass(this.backdrop, 'dropdown-menu-bg');

    const toggle = this.el.nativeElement.querySelector('[ngbDropdownToggle]');

    if (toggle?.nextSibling) {
      this.renderer.insertBefore(
        this.el.nativeElement,
        this.backdrop,
        toggle.nextSibling
      );
    } else {
      this.renderer.appendChild(this.el.nativeElement, this.backdrop);
    }
  }

  ngOnDestroy() {
    this.backdrop?.remove();
  }
}
